<header class="top-header">
  <div class="header-container-logo">
    <a
      href="#"
      class="nav-menu-button hidden-print"
      [ngClass]="{ active: navActive && !quickActionsOpen }"
      (click)="onNavBtnClick($event)"
      [attr.aria-label]="navActive ? 'Close Menu' : 'Open Menu'">
      <span class="nav-menu-icon" aria-hidden="false"></span>
    </a>
    <a routerLink="/" (click)="quickActionsToggled.emit(false)" class="logo" [attr.aria-label]="productName">
      <svg-icon [src]="(themeService.theme$ | async)?.iconUrl"></svg-icon>
    </a>
  </div>
  <kp-core-nav
    class="nav-component-container hidden-print"
    [quickActionsOpen]="quickActionsOpen"
    (quickActionsToggled)="quickActionsToggled.emit($event)"></kp-core-nav>
  <div class="header-container-tertiary-visible">
    <kp-purposeful-days
      *ngIf="externalProduct === product.purposeful"
      (purposefulDaysClicked)="quickActionsToggled.emit(false)"></kp-purposeful-days>
    <div class="header-container-tertiary hidden-print">
      <ng-container *ngIf="externalProduct === product.resourceful">
        <a
          routerLink="/cards/saved"
          (click)="quickActionsToggled.emit(false)"
          routerLinkActive="header-active"
          class="button-icon"
          aria-label="Saved cards">
          <svg-icon src="/assets/icons/save-filled.svg"></svg-icon>
        </a>
        <a
          routerLink="/feedback"
          (click)="quickActionsToggled.emit(false)"
          routerLinkActive="header-active"
          class="button-icon"
          aria-label="Feedback">
          <svg-icon src="/assets/icons/feedback.svg"></svg-icon>
        </a>
      </ng-container>
      <a
        routerLink="/help"
        (click)="quickActionsToggled.emit(false)"
        routerLinkActive="header-active"
        class="button-help"
        aria-label="Help">
        <svg-icon src="/assets/icons/question-filled-circle.svg"></svg-icon>
      </a>
      <ng-container *ngIf="navigationBloc.moreApps$ | async as moreApps">
        <a
          *ngIf="moreApps.length > 1"
          (click)="quickActionsToggled.emit(false)"
          class="app-switcher-button"
          aria-label="More apps">
          <kui-app-switcher [apps]="moreApps" (appClicked)="appClicked($event)"></kui-app-switcher>
        </a>
      </ng-container>
    </div>
  </div>
</header>
